import { useMemo } from 'react';
import { useBusinessSettings } from '../context/BusinessSettingsContext';
import { computeCartTax } from '../data/businessDefaults';

export default function CartSticky({ cart, onOpen }) {
  const { formatPrice, business } = useBusinessSettings();
  const count = cart.reduce((s, i) => s + i.qty, 0);
  const subtotal = cart.reduce((s, i) => s + i.price * i.qty, 0);
  const { totalDue } = useMemo(() => computeCartTax(subtotal, business), [subtotal, business]);

  if (count === 0) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '1.5rem',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 950,
        animation: 'slideUp .3s ease both',
        paddingBottom: 'env(safe-area-inset-bottom, 0)',
      }}
    >
      <button
        onClick={onOpen}
        style={{
          background: '#fff',
          color: 'var(--teal-dark)',
          border: '2px solid rgba(15, 90, 104, 0.45)',
          borderRadius: 'var(--radius-pill)',
          padding: '.85rem 1.85rem',
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          boxShadow:
            '0 4px 6px rgba(0,0,0,0.08), 0 14px 36px rgba(0,0,0,0.22), 0 0 0 1px rgba(255,255,255,0.85) inset',
          fontFamily: 'var(--font-body)',
          fontWeight: 600,
          fontSize: '1rem',
          transition: 'all .22s cubic-bezier(.34,1.56,.64,1)',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.03)';
          e.currentTarget.style.background = '#f4fafb';
          e.currentTarget.style.boxShadow =
            '0 6px 10px rgba(0,0,0,0.1), 0 18px 44px rgba(0,0,0,0.26), 0 0 0 1px rgba(255,255,255,0.9) inset';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.background = '#fff';
          e.currentTarget.style.boxShadow =
            '0 4px 6px rgba(0,0,0,0.08), 0 14px 36px rgba(0,0,0,0.22), 0 0 0 1px rgba(255,255,255,0.85) inset';
        }}
        aria-label={`Your order: ${count} items, total ${formatPrice(totalDue)}`}
      >
        <span
          style={{
            background: 'var(--red)',
            color: 'white',
            width: 26, height: 26,
            borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '.78rem',
            fontWeight: 800,
          }}
        >
          {count}
        </span>
        <span>Your order</span>
        <span style={{ opacity: .8, fontSize: '.88rem' }}>{formatPrice(totalDue)}</span>
      </button>
    </div>
  );
}
